import { ThemePerformanceParams } from '@api/api/theme-overview';
import { useGetV5ThemePerformance } from '@terminal/react-query-hooks/themes/useGetV5ThemePerformance';
import { useGetV7ThemePerformance } from '@terminal/react-query-hooks/themes/useGetV7ThemePerformance';
import { useFlags } from '@terminal/stores/use-flags/useFlags';
import { useMemo } from 'react';

export const useGetThemePerformance = (
  params?: ThemePerformanceParams,
  enabled = true
) => {
  const isV7ThemePerformance = useFlags(state =>
    state.getFeatureFlagState('KG-840-api_entity-performance-v7')
  );

  const v5ThemePerformance = useGetV5ThemePerformance(
    params,
    enabled && !isV7ThemePerformance
  );
  const v7ThemePerformance = useGetV7ThemePerformance(
    params,
    enabled && isV7ThemePerformance
  );

  const activeThemePerformance = isV7ThemePerformance
    ? v7ThemePerformance
    : v5ThemePerformance;

  const themes = useMemo(
    () => activeThemePerformance.data?.pages?.flatMap(p => p.themes),
    [activeThemePerformance.data]
  );

  return {
    ...activeThemePerformance,
    themes,
    hasAnyError: activeThemePerformance.isError,
  };
};
